export const listItemSessions = [
  'userinfo',
  'liffAccessToken',
  'isEatIn',
  'pictureUrl',
  'displayName',
  'userAuthInfo',
  'orderId',
  'goodsId',
  'cartGoods',
  'bagMoney',
  'jumpPath',
  'storeId',
  'storeName',
  'searchStoreFilterList',
  'googleMapLatLngList',
  'cartItem',
  'infoCoupon',
  'typeCoupon',
  'tax',
  'transNo',
  'goodsCategoryId',
  'goodCouponId',
  'goodsName'
];

export const CONFIRM_CATEGORY = {
  title: '受取店舗を変更します',
  content:
    '受取店舗を変更すると、店舗ごとに取り扱い商品が異なるためショッピングカートが空になります。<br />大変申し訳ございませんが、商品を選択し直していただくようお願いいたします。​',
  textCancel: 'キャンセル',
  textSubmit: '変更する'
};

export const dataIced = [
  {
    label: 's',
    value: 's',
    price: 340,
    icon: require('@/assets/images/v2/icon-iced-s.svg'),
    display: false
  },
  {
    label: 'm',
    value: 'm',
    price: 370,
    icon: require('@/assets/images/v2/icon-iced-m.svg'),
    display: true
  },
  {
    label: 'l',
    value: 'l',
    price: 420,
    icon: require('@/assets/images/v2/icon-iced-l.svg'),
    display: true
  }
];
export const dataHot = [
  {
    label: 's',
    value: 's',
    price: 340,
    icon: require('@/assets/images/v2/icon-iced-s.svg')
  },
  {
    label: 'm',
    value: 'm',
    price: 370,
    icon: require('@/assets/images/v2/icon-iced-m.svg'),
    display: true
  }
];

export const LIST_CHOOSE_SWEETS = [
  {
    value: 'zero',
    label: 'ゼロ',
    price: 0,
    icon: require('@/assets/images/v2/icon-sweet-zero.svg')
  },
  {
    value: 'less',
    label: '少なめ',
    price: 0,
    icon: require('@/assets/images/v2/icon-sweet-less.svg')
  },
  {
    value: 'odinary',
    label: 'ふつう',
    price: 0,
    icon: require('@/assets/images/v2/icon-sweet-odinary.svg')
  },
  {
    value: 'alot',
    label: '多め',
    price: 0,
    icon: require('@/assets/images/v2/icon-sweet-alot.svg')
  }
]

export const LIST_CHOOSE_ICES = [
  {
    value: 'zero',
    label: 'ゼロ',
    price: 80,
    icon: require('@/assets/images/v2/icon-ice-zero.svg')
  },
  {
    value: 'less',
    label: '少なめ',
    price: 0,
    icon: require('@/assets/images/v2/icon-ice-less.svg')
  },
  {
    value: 'odinary',
    label: 'ふつう',
    price: 0,
    icon: require('@/assets/images/v2/icon-ice-odinary.svg')
  },
  {
    value: 'alot',
    label: '多め',
    price: 0,
    icon: require('@/assets/images/v2/icon-ice-alot.svg')
  }
]

export const titleFirst = {
  number: '01',
  content: 'サイズ',
  required: true
}

export const TITLE_SWEET = {
  number: '02',
  content: '甘さ（シロップ量）',
  required: true
}

export const titleIce = {
  number: '03',
  content: '氷',
  required: true
}

export const TITLE_TOPPING = {
  number: '04',
  content: 'トッピング',
  required: false
}

export const confirmCard = {
  title: '受取店舗を変更します',
  content:
    '受取店舗を変更すると、店舗ごとに取り扱い商品が異なるためショッピングカートが空になります。<br/>大変申し訳ございませんが、商品を選択し直していただくようお願いいたします。​',
  textCancel: 'キャンセル',
  textSubmit: '変更する'
};
